module.exports = __webpack_public_path__ + "static/media/Points_Cards.96939b0d.png";